import { useQuery, useMutation, useQueryClient } from 'react-query';
import * as apiKeysApi from '../api/apiKeys';
import { CreateApiKeyData } from '../api/apiKeys';

export const apiKeysKey = ['apiKeys'] as const;

export const useApiKeys = (includeRevoked?: boolean) => {
    return useQuery({
        queryKey: [...apiKeysKey, { includeRevoked }],
        queryFn: () => apiKeysApi.getApiKeys(includeRevoked),
    });
};

export const useCreateApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateApiKeyData) => apiKeysApi.createApiKey(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: apiKeysKey });
        },
    });
};

export const useRevokeApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (apiKeyId: number) => apiKeysApi.revokeApiKey(apiKeyId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: apiKeysKey });
        },
    });
};
